import shalomLogo from "@/assets/shalom-logo-blue-transparent.png";

type BrandMarkProps = {
  className?: string;
};

export function BrandMark({ className }: BrandMarkProps) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      data-shalom-brand-mark="shield-circle-shalom-logo"
    >
      <path
        d="M24 4.5 39 9.8v11.8c0 9.2-6.1 17.7-15 21.9C15.1 39.3 9 30.8 9 21.6V9.8L24 4.5Z"
        fill="currentColor"
        opacity="0.18"
      />
      <path
        d="M24 4.5 39 9.8v11.8c0 9.2-6.1 17.7-15 21.9C15.1 39.3 9 30.8 9 21.6V9.8L24 4.5Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <circle cx="24" cy="22.5" r="10.5" fill="white" />
      <circle cx="24" cy="22.5" r="9" stroke="currentColor" strokeWidth="1.8" opacity="0.88" />
      <image
        href={shalomLogo}
        x="16"
        y="14.5"
        width="16"
        height="16"
        preserveAspectRatio="xMidYMid meet"
      />
    </svg>
  );
}
